import {
  BAR_WIDTH,
  BAR_CHART_BAR_PADDING,
  OTHER_LABEL,
  CHART_LABEL_CHAR_WIDTH,
} from '../constants';
import { BarChartData } from '../types';

export const determineBarsToShow = (
  data: BarChartData,
  chartWidth: number,
): { maxBars: number; maxLabelWidth: number } => {
  // Find the longest label and estimate its width
  let longestLabelCharCount = 0;

  for (const item of data) {
    const charCount = item.name.length;
    if (charCount > longestLabelCharCount) {
      longestLabelCharCount = charCount;
    }
  }
  const maxLabelWidth = Math.min(longestLabelCharCount * CHART_LABEL_CHAR_WIDTH, BAR_WIDTH * 2.5);
  const minWidthPerBar = Math.max(BAR_WIDTH, maxLabelWidth);
  const spaceNeededPerBar = minWidthPerBar * (1 + BAR_CHART_BAR_PADDING);

  // Calculate maximum bars that can fit
  const maxBars = Math.floor(chartWidth / spaceNeededPerBar);

  // Limit the visible data to what fits
  return { maxBars: Math.max(1, Math.min(maxBars, data.length)), maxLabelWidth };
};

export const bisectBarData = (
  data: BarChartData,
  maxPrimaryDataLength: number,
): {
  primaryData: BarChartData;
  secondaryData?: BarChartData;
  totalValue: number;
} => {
  const totalValue = data.reduce((acc, curr) => acc + curr.value, 0);
  if (data.length > maxPrimaryDataLength) {
    const primaryData = [
      ...data.slice(0, maxPrimaryDataLength - 1),
      {
        name: OTHER_LABEL,
        value:
          totalValue -
          data.slice(0, maxPrimaryDataLength - 1).reduce((acc, curr) => acc + curr.value, 0),
      },
    ];
    const secondaryData = data.slice(maxPrimaryDataLength - 1);

    return {
      primaryData,
      secondaryData,
      totalValue,
    };
  } else {
    return {
      primaryData: data,
      totalValue,
    };
  }
};
